import * as React from "react"
import { Box } from "@mui/material"
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components"
import { LIMITS_VIEWS } from "../@constants"
import { CommonIconButton } from "../../@components"


export default function marketColumn() {
	return [{
		name: 'country', label: 'Market',
		options: {
			display: 'excluded',
            filterType: "textField",
			customBodyRowRender: (_, row) => {
				if (!row?.country || row.country.length === 0) {
                    return "Empty"
                }

				const markets = row?.country.map(market  => translateCountryName(market))
				return markets.join() 
			}
		}
	},{
		name: "country", label: 'Markets',
		options: {
			filter: false,
			setCellProps: () => ({ sx: { maxWidth: 125} }),
			customBodyRowRenderLite: (value, row) => {
				return <Box sx={{display:'flex', flexWrap:'wrap', gap: 1}}>
                    { value && value.map((item, index) => <LabelCountry country={item} label={translateCountryName(item)} key={index} />) }
                    { value?.length > LIMITS_VIEWS.COUNTRIES && <CommonIconButton alertSelected={row} />}

                </Box>
			}
		}
	}]
}